import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CreateProfile,
  Profile,
  BaseProfileData,
  ProfileConfig,
  Notification,
} from '../../shared/models/users-profile.models';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private http = inject(HttpClient);

  createProfile(profile: CreateProfile): Observable<Profile> {
    return this.http.post<Profile>('/employee-controller/profile', profile);
  }

  getOneByUserId(userId: string): Observable<Profile> {
    return this.http.get<Profile>(`/employee-controller/profile/user/${userId}`);
  }

  updateProfile(
    userId: string,
    profileData: Partial<Profile>,
    image?: File | null,
  ): Observable<void> {
    const formData = new FormData();

    if (image) {
      formData.append('image', image);
    }

    Object.keys(profileData).forEach((key) => {
      formData.append(key, JSON.stringify(profileData[key]));
    });

    return this.http.patch<void>(`/employee-controller/profile/user/${userId}`, formData);
  }

  getBaseProfileDataByUserId(userId: string): Observable<BaseProfileData> {
    return this.http.get<BaseProfileData>(`/employee-controller/profile/user/${userId}/base`);
  }

  getBaseProfileDataByUsersIds(ids: string[]): Observable<BaseProfileData[]> {
    return this.http.post<BaseProfileData[]>('/employee-controller/profile/users-ids', ids);
  }

  updateProfileConfig(profileId: string, config: Partial<ProfileConfig>): Observable<void> {
    return this.http.patch<void>(`/employee-controller/profile/${profileId}/config`, config);
  }

  getAllProfiles(page: number): Observable<[Profile[], number]> {
    return this.http.get<[Profile[], number]>(`/employee-controller/profile?page=${page}`);
  }

  getProfileNotifications(): Observable<{ read: Notification[]; unread: Notification[] }> {
    return this.http.get<{ read: Notification[]; unread: Notification[] }>(
      '/employee-controller/notifications',
    );
  }

  markNotificationAsRead(notificationId: string): Observable<void> {
    return this.http.patch<void>(`/employee-controller/notifications/${notificationId}`, null);
  }
}
